<template>
  <div :class="$style.container">
    <p :class="$style.price">
      {{ medianPriceData[propertyType].price }} CHF/<span>m<sup>2</sup></span>
    </p>
    <div :class="$style.rangeBar" data-testid="range-bar">
      <div :class="$style.rangeBarInner" />
    </div>
    <div :class="$style.rangeTextWrapper">
      <span>{{ medianPriceData[propertyType].range.min }} CHF/m<sup>2</sup></span>
      <span>{{ medianPriceData[propertyType].range.max }} CHF/m<sup>2</sup></span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { type MedianPriceData } from '@/components/median-price/adaptData';
import useMapStore from '@/stores/useMapStore';

interface Props {
  medianPriceData: MedianPriceData;
}

const { medianPriceData } = defineProps<Props>();

const mapStore = useMapStore();
const { propertyType } = storeToRefs(mapStore);
</script>

<style lang="scss" module>
@use '@/styles/variables' as *;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.price {
  margin-top: 0;
  margin-bottom: $space-100;

  @include grid-media-query(sm) {
    margin-bottom: $space-50;
  }

  @include body-1-bold;
}

.rangeBar {
  width: 100%;
  height: 6px;
  margin-bottom: $space-100;
  background-color: $color-grey-50;
  border-radius: $border-radius;
}

.rangeBarInner {
  width: 80%;
  height: 100%;
  margin: 0 auto;
  background-color: $color-blue-60;
  border-radius: $border-radius;
}

.rangeTextWrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;

  @include body-2;
}
</style>
